<template>
    <div class="modal fade" id="kt_modal_1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" style="display: none;">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">{{ labels.missing_fields }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    </button>
                </div>
                <div class="modal-body validation-body">
                    <ul>
                        <li v-for="field in requiredFields" v-if="field !== 'product_id'">
                            <i class="la la-check-circle-o status-icon true" v-if="formValidation.indexOf(field) === -1"></i>
                            <i class="la la-times-circle-o status-icon false" v-else></i>
                            <span>{{ labels.productFields[field] }}</span>
                        </li>
                    </ul>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-success" data-dismiss="modal">Ok</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: ['formValidation', 'requiredFields'],
  computed: {
    ...mapState({
      labels: (state) => state.labels,
    }),
  },
};
</script>

<style>
    .status-icon {
        font-size: 1.5rem;
        font-weight: bold;
    }
    .status-icon.true {
        color:#05d817;
    }
    .status-icon.false {
        color: #fe5f55;
    }
    .validation-body {
        background-color: #ffffff;
    }
    .validation-body li{
        list-style: none;
    }
    .validation-body span{
        color: #092938;
        font-size: 1.3rem;
    }
    .modal-header {
        background-color: #ffcc01;
        border: 1px solid #ffcc01;
    }
    .modal-footer {
        background-color: #ffcc01;
        border: 1px solid #ffcc01;
    }

</style>



// WEBPACK FOOTER //
// src/components/Modals/ProductFormModal.vue